import { InterfaceProduct, MechProduct, ProductOrientation, SkinProductOption } from '../types/productTypes'
import { isANullableString, isANumber, isAnyObject, isAString } from '../utils/typeChecking'

export interface ConfiguredInterface {
  interfaceItemNo: string
  mechItemNo: string | null
}

export interface ConfiguredProduct {
  skinItemNo: string
  interfaces: readonly ConfiguredInterface[]
  ledEnabled: boolean
  orientation: ProductOrientation
  uid: string
}

export interface ConfiguredProductListItem {
  configuredProduct: ConfiguredProduct
  quantity: number
  note: string
  roomId: string | null
}

export function isConfiguredProductListItem(value: unknown): value is ConfiguredProductListItem {
  if (!isAnyObject(value)) {
    return false
  }

  const item = value as ConfiguredProductListItem

  return (
    // configuredProduct: ConfiguredProduct
    isAnyObject(item.configuredProduct)
    // quantity: number
    && isANumber(item.quantity)
    // note: string
    && isAString(item.note)
    // roomId: string | null
    && isANullableString(item.roomId)
  )
}

export interface InflatedConfiguredInterfaceProduct {
  interfaceProduct: InterfaceProduct
  mechProduct: MechProduct | null
  parentInterfaceProduct?: InterfaceProduct | null
}

export interface InflatedListItemProduct {
  skinProduct: SkinProductOption
  configuredButtons: readonly InflatedConfiguredInterfaceProduct[]
  ledEnabled: boolean
  uid: string
  quantity: number
  note: string
  roomId: string | null
  ledIncluded?: boolean
}

export interface Room {
  name: string
  uid: string
}

export function isRoom(value: unknown): value is Room {
  if (!isAnyObject(value)) {
    return false
  }

  const room = value as Room

  return (
    typeof room.name === 'string'
      && typeof room.uid === 'string'
  )
}

export interface ListRoom extends Room {
  expanded: boolean
}
